/* Terraloo Sleek — async product recommendations */
(function () {
  'use strict';

  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(this);
              this.loadRecommendations(url);
            }.bind(this)
          );
        }.bind(this),
        { rootMargin: '400px' }
      );
      observer.observe(this);
    }

    loadRecommendations(url) {
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(
          function (html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var fresh = temp.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) {
              this.innerHTML = fresh.innerHTML;
            } else {
              this.remove();
            }
          }.bind(this)
        )
        .catch(function () {});
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
